<script setup>
import { computed, inject } from 'vue';

const I18n = inject('I18n');

const props = defineProps({
  label: {
    type: [String, Boolean],
    default: false,
  },
});

const labelText = computed(() => {
  if (props.label === true) {
    return `${I18n.t('cargando')}...`;
  }
  return props.label;
});
</script>

<template>
  <div class="text-center">
    <i class="fa fa-fw fa-circle-notch fa-spin fa-3x text-cifra"></i>
    <div v-if="label" class="spinner-label">
      {{ labelText }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner-label {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}
</style>
